export default __webpack_public_path__ + "static/hero-flight-delay-pass-6f065ea9aed55e69950b3a877ce0307d.png";